<template>
  <div>
    <!-- The title -->
    <div class="minorTitle">
      Shipping Details
    </div>

    <!-- The address and shipping details -->
    <div class="accountMenuFullHeightContainer">
      <div class="marginNoneBottom">
        <!-- Only if they have items for which fullfillment arrangements must be made. -->
        <div v-if="requestQuoteInventoryIds.length > 0">
          <p class="marginSmallBottom">
            Please provide the address to which you would like the shipment delivered.
          </p>

          <!-- The shipping address -->
          <div class="marginLargeTop marginLargeBottom">
            <div class="row">
              <div class="twelve columns">
                <div class="paddingSmallBottom">
                  Street Address Line 1
                </div>
                <input
                  id="street_1"
                  ref="street_1"
                  v-model="payload.street_1"
                  type="text"
                  name="street_1"
                  required
                >
              </div>
            </div>
            <div class="row">
              <div class="twelve columns">
                <div
                  class="paddingNormalTop paddingSmallBottom"
                  :class="{ colorLightGrey: payload.street_1.length === 0 }"
                >
                  Street Address Line 2
                </div>
                <input
                  id="street_2"
                  ref="street_2"
                  v-model="payload.street_2"
                  type="text"
                  name="street_2"
                  required
                  :disabled="payload.street_1.length === 0"
                >
              </div>
            </div>
            <div class="row">
              <div class="six columns">
                <div class="paddingNormalTop paddingSmallBottom">
                  City
                </div>
                <input
                  id="city"
                  ref="city"
                  v-model="payload.city"
                  type="text"
                  name="city"
                  required
                >
              </div>
              <div class="three columns">
                <div class="paddingNormalTop paddingSmallBottom">
                  State
                </div>
                <input
                  id="state"
                  ref="state"
                  v-model="payload.state"
                  type="text"
                  name="state"
                  required
                >
              </div>
              <div class="three columns">
                <div class="paddingNormalTop paddingSmallBottom">
                  Zip
                </div>
                <input
                  id="zip"
                  ref="zip"
                  v-model="payload.zip"
                  type="text"
                  name="zip"
                  required
                >
              </div>
            </div>
            <div class="row">
              <div class="twelve columns">
                <div class="paddingNormalTop paddingSmallBottom">
                  Country
                </div>
                <input
                  id="country"
                  ref="country"
                  v-model="payload.country"
                  type="text"
                  name="country"
                  required
                >
              </div>
            </div>
          </div>

          <!-- The shipping speed -->
          <div class="marginLargeBottom">
            <div class="row">
              <div class="one columns">
                <input
                  id="standard"
                  v-model="payload.expedited"
                  class="hiddenInput"
                  name="expedited"
                  value="false"
                  type="radio"
                >
                <label
                  for="standard"
                  class="radioCheckboxOutline"
                >
                  <div class="radioCheckbox">
                    <div class="radioCheck" />
                  </div>
                </label>
              </div>
              <div class="eleven columns">
                <div class="minorTitle paddingNoneTop paddingSmallBottom">
                  Standard Shipping
                </div>
                <p>
                  Select standard shipping to receive a quote for our most economical shipping method. These quotes are processed in the order in which they are received.
                </p>
              </div>
            </div>
            <div class="row marginNormalBottom">
              <div class="one columns">
                <input
                  id="expedited"
                  v-model="payload.expedited"
                  class="hiddenInput"
                  name="expedited"
                  value="true"
                  type="radio"
                >
                <label
                  for="expedited"
                  class="radioCheckboxOutline"
                >
                  <div class="radioCheckbox">
                    <div class="radioCheck" />
                  </div>
                </label>
              </div>
              <div class="eleven columns">
                <div class="minorTitle paddingNoneTop paddingSmallBottom">
                  Expedited Shipping
                </div>
                <p>
                  Select expedited shipping to receive a quote in the quickest time frame for our fastest shipping method. This option may not be the most economical.
                </p>
              </div>
            </div>
            <div class="paddingNormalBottom">
              Please provide any special instructions regarding this quote that you would like to share with our Shipping Department:
            </div>
            <div class="twelve columns marginNormalBottom">
              <div
                class="paddingNoneTop paddingSmallBottom"
                :class="{ colorLightGrey: payload.expedited === null }"
              >
                Special Instructions
              </div>
              <input
                id="special_instruction"
                v-model="payload.special_instructions"
                type="text"
                name="special_instruction"
                required
                :disabled="payload.expedited === null"
              >
            </div>
            <div class="paddingSmallTop paddingNormalBottom">
              Leland Little Auctions' (LLA) in-house Shipping Department works in partnership with Packaging Express to handle shipments.  By requesting a shipping quote, you authorize LLA to act as your agent to sign any such documents required, and agree to fully indemnify LLA for any claims made by Packaging Express.
            </div>
            <div class="marginLargeBottom">
              <!-- The response from the api is displayed here -->
              <ApiResponse :context="'process_shipping_arrangement'" />

              <!-- The button is disabled until they specify expedited and enter a street value -->
              <button
                v-if="payload.expedited === null || payload.street_1 === '' || payload.city === '' || payload.state === '' || payload.zip === '' || payload.country === ''"
                class="bidButton disabledButton"
              >
                Request a Shipping Quote
              </button>

              <!-- Otherwise the button is spinning if the api is pending for this context -->
              <button
                v-else-if="typeof (apiPending.process_shipping_arrangement) !== 'undefined'"
                class="disabledButton bidButton u-full-width"
                disabled="disabled"
              >
                <span class="loading" />
              </button>

              <!-- And finally, the botton is a clickable button. -->
              <button
                v-else
                type="submit"
                class="bidButton backgroundColorDefault u-full-width"
                @click="processShippingArrangement('process_shipping_arrangement')"
              >
                Request a Shipping Quote
              </button>
            </div>
          </div>
        </div>
        <div
          v-else
          class="colorGrey paddingLargeBottom"
        >
          Thank you, your quote request has been received.  Our shipping department will be in touch soon.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ApiResponse from '@/components/ApiResponse.vue'

export default {
	name: 'ShippingDetailsCard',
	components: {
		ApiResponse
	},
  data () {
    return {
		'payload': {
			'inventory_ids': [],
			'street_1': '',
			'street_2': '',
			'city': '',
			'state': '',
			'zip': '',
			'country': '',
			'expedited': null,
			'special_instructions': '',
			'context': ''
		}
    }
  },
  computed: {
    apiPending: function () {
      return this.$store.getters.apiPending
    },
	requestQuoteInventoryIds: function () {
		return this.$store.getters.requestQuoteInventoryIds
	}
  },
  methods: {
	processShippingArrangement (context) {
		// string to boolean	
		if(this.payload.expedited === 'true'){
			this.payload.expedited = true
		} else if (this.payload.expedited === 'false'){
			this.payload.expedited = false
		}
		this.payload.context = context
		this.payload.inventory_ids = this.requestQuoteInventoryIds;
		this.$store.dispatch('processShippingArrangement', this.payload)
	}
  }
}

</script>

<style scoped>

</style>
